import { Col, Row } from 'antd'
import { AvatarImg } from 'components/atoms'
import { NO_DATA } from 'constants/common'
import { IPatient } from 'pages/patientReceive/interfaces'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { getDateOfBirthString, getOldPatient } from 'utils'

const StyleItem = styled.div``
const StyleBioInformation = styled.div`
  display: flex;
  align-items: center;
  div + div:before {
    content: '';
    display: inline-block;
    width: 1px;
    background-color: var(--color-gray-102);
    height: 12px;
    margin: 0 10px;
  }
`
const StyledValue = styled.span`
  font-weight: 700;
  font-size: 1.4rem;
  margin-left: 4px;
`
const StyledContent = styled(Col)`
  line-height: 28px;
`

interface IProps {
  patient?: IPatient
}
const ProfileClassic = (props: IProps) => {
  const { patient } = props
  const { t } = useTranslation()
  return (
    <Row>
      <Col span={6}>
        <AvatarImg img={patient?.avatar_url} value={patient?.full_name} />
      </Col>
      <StyledContent span={18}>
        <StyleItem>
          {t('patient-code')}:
          <StyledValue>{patient?.user_code || NO_DATA}</StyledValue>
        </StyleItem>
        <StyleItem>
          {t('full-name')}:
          <StyledValue>{patient?.full_name || NO_DATA}</StyledValue>
        </StyleItem>
        <StyleBioInformation>
          <StyleItem>
            {t('gender')}:
            <StyledValue>
              {patient?.gender ? t(`gender-${patient?.gender}`) : NO_DATA}
            </StyledValue>
          </StyleItem>
          <StyleItem>
            {t('birthday-date')}:
            <StyledValue>
              {patient?.date_of_birth
                ? getDateOfBirthString(
                    patient?.date,
                    patient?.month,
                    patient?.year
                  )
                : NO_DATA}
            </StyledValue>
          </StyleItem>
          <StyleItem>
            {t('old')}:
            <StyledValue>
              {patient?.date_of_birth ? getOldPatient(patient?.year) : NO_DATA}
            </StyledValue>
          </StyleItem>
        </StyleBioInformation>
        <StyleItem>
          {t('address')}:{' '}
          <StyledValue>{patient?.address || NO_DATA}</StyledValue>
        </StyleItem>
      </StyledContent>
    </Row>
  )
}

export default ProfileClassic
